module.exports = __webpack_public_path__ + "img/logo-衡阳第四人民医院.19e7d12f.png";